import React from "react";
import NoDataFound from "../NoDataFound";
import { FlatList, Image, Text, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import Ionicons from "@expo/vector-icons/Ionicons";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import { AppScreens } from "../../screens/Utility/AppScreens";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { ShowLoader } from "../../common/ShowLoader";
import Avatar from "../choose-avatar-components/Avatar";

const UserListingWithPagination = ({
  UserDataEmpty,
  userResult,
  currentPage,
  setCurrentPage,
  userData,
  showLoader,
}) => {
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const ITEMS_PER_PAGE =
    deviceSize === DEVICE_SIZES.SM ||
    deviceSize === DEVICE_SIZES.XS ||
    deviceSize === DEVICE_SIZES.MD ||
    deviceSize === DEVICE_SIZES.LG
      ? 6
      : 9;
  const getCurrentPageData = () => {
    const startIndex = currentPage * ITEMS_PER_PAGE;
    return userResult?.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  };

  const handleNextPage = () => {
    if ((currentPage + 1) * ITEMS_PER_PAGE < userResult?.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };
  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      {currentPage > 0 && (
        <TouchableOpacity
          activeOpacity={0.5}
          style={{
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
          onPress={handlePreviousPage}
        >
          <Ionicons name="arrow-back" size={35} color={AppColors.white} />
        </TouchableOpacity>
      )}
      <FlatList
        data={getCurrentPageData()}
        style={{ gap: 8 }}
        key={3}
        numColumns={
          deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG
            ? 2
            : 3
        }
        columnWrapperStyle={{
          // flex: 1,
          gap: 8,
        }}
        renderItem={({ item, index }) => (
          <TouchableOpacity
            style={{
              flexDirection: "row",
              flex:
                deviceSize === DEVICE_SIZES.SM ||
                deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.MD ||
                deviceSize === DEVICE_SIZES.LG
                  ? 1 / 2
                  : 1 / 3,
              paddingVertical: 10,
              marginBottom: 8,
              gap: 10,
            }}
            onPress={() => {
              if (userData.username === item.userID) {
                navigateToScreen(navigation, AppScreens.Profile);
              } else {
                navigateToScreen(navigation, AppScreens.UserProfile, {
                    username: item.userID,
                  });
              }
            }}
          >
            <Avatar src={item.profilePicture} variant="player" />
            <View
              style={{
                justifyContent: "center",
                flex: 1,
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_14,
                  { color: AppColors.white },
                ]}
              >
                {item.userID}
              </Text>
            </View>
          </TouchableOpacity>
        )}
      />

      {(currentPage + 1) * ITEMS_PER_PAGE < userResult?.length && (
        <TouchableOpacity
          activeOpacity={0.5}
          style={{
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
          onPress={handleNextPage}
        >
          <Ionicons name="arrow-forward" size={35} color={AppColors.white} />
        </TouchableOpacity>
      )}
    </View>
  );
};

export default UserListingWithPagination;
